<template>
  <UpsellItemBase
    :title="props.upsell.product.name"
    :subtitle="props.upsell.product.subTitle"
    :price="calculatedPrice"
    :original-price="props.upsell.product.price"
    :sku="upsell.baseSKU"
    :selected="upsell.isInCart"
    :upsell="upsell"
    :index="index"
    :discount="discount"
  />
</template>

<script setup>
const props = defineProps({
  upsell: { type: Object, default: () => ({}) },
  index: { type: Number, default: 0 }
})

const discount = computed(() => {
  const shopifyStore = useShopifyStore()

  return shopifyStore.getDiscountsForProductFromCartItems(
    props.upsell.product
  )?.[0]
})

const isFreeOnPromo = computed(() => {
  if (discount.value) {
    return discount.value.discountSummary.discountIsFree
  }

  return false
})

const calculatedPrice = computed(() => {
  if (isFreeOnPromo.value) return 0

  if (discount.value) {
    if (discount.value.discountSummary.discountType === 'DiscountPercentage') {
      return props.upsell.product.price * (1 - discount.value.discountSummary.discountPercentageOff)
    }

    if (discount.value.discountSummary.discountType === 'DiscountAmount') {
      return props.upsell.product.price - discount.value.discountSummary.discountAmountOff
    }
  }

  return props.upsell.product.price
})
</script>
